// extracted by mini-css-extract-plugin
export default {"page-wrapper":"PageWrapper_page-wrapper__tTTfJ","page-wrapper-inner":"PageWrapper_page-wrapper-inner__W9vHz"};